import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share";

import Grid from "@material-ui/core/Grid";

//import ReactTooltip from "react-tooltip"

const useStyles = makeStyles({
  root: {
    width: "200px",
    //padding:'10px',
    //height: '40px',
    textAlign: "left",
  },
  shareWith: {
    display: "inline-block",
    verticalAlign: "middle",
    height: "30px",
    width: "65px",
    fontSize: "14px",
  },
  buttonContainer: {
    paddingLeft: "5px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    verticalAlign: "middle",
  },
  hoverable: {
    backgroundColor: "rgba(255,255,255,0)!important",
    "&:hover": {
      cursor: "pointer",
    },
    minHeight: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px",
    marginLeft: "15px",
  },
  imageContainer: {
    //position:'absolute',
    //border:'1px solid black',
    width: "30px",
    height: "30px",
    //borderRadius: '5px',
    //clipPath: 'circle(35px at 50% 50%)',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  selectorImage: {
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center!important",
    width: "20px",
    height: "20px",
  },
  facebook: {
    backgroundImage: 'url("/images/social_media/facebook.svg")',
  },
  twitter: {
    backgroundImage: 'url("/images/social_media/twitter.svg")',
  },
  linkedin: {
    backgroundImage: 'url("/images/social_media/linkedin.svg")',
  },
  instagram: {
    backgroundImage: 'url("/images/social_media/instagram.svg")',
  },
  toolTip: {
    textAlign: "left",
    color: "#00000!important",
    backgroundColor: "#aaaaaa",
    fontFamily: "Flanders Art Sans!important",
  },
});

export default function SocialMediaBlock(props) {
  const classes = useStyles();

  let sharingTitle;
  //let sharingUrl = "https://vibrant-rosalind-639ec0.netlify.app/";
  let sharingUrl = "https://stroomvoorspeller.netlify.app/";
  switch (props.source) {
    case "indicators":
      //sharingTitle = "Productie in Vlaanderen";
      sharingUrl += "indicatoren/";
      break;
    case "provinces":
      //sharingTitle = "Productie per provincie";
      sharingUrl += "provincies/";
      break;
    case "records":
      //sharingTitle = "Groene stroom - Records";
      sharingUrl += "records/";
      break;
    case "timeplot":
      //sharingTitle = "Productie in Vlaanderen";
      sharingUrl += "grafieken/";
      break;
    default:
  }
  if (props.currentMode === "realtime") {
    sharingUrl += "realtime/";
    if (props.source !== "records"){
      sharingUrl += props.daySelected;
    }    
  } 
  else {
    sharingUrl += "jaar/";
    sharingUrl += props.yearSelected;
  }
  
  if (props.source !== "records" || props.currentMode !== "realtime"){
    sharingUrl += "_"
  }

  if (props.currentTech.solar) {
    if (props.currentTech.wind) {
      if (props.currentTech.windOffshore) {
        sharingUrl += "zon_windonshore_windoffshore";
      } else {
        sharingUrl += "zon_windonshore";
      }
    } else {
      if (props.currentTech.windOffshore) {
        sharingUrl += "zon_windoffshore";
      } else {
        sharingUrl += "zon";
      }
    }
  } else {
    if (props.currentTech.wind) {
      if (props.currentTech.windOffshore) {
        sharingUrl += "windonshore_windoffshore";
      } else {
        sharingUrl += "windonshore";
      }
    } else {
      sharingUrl += "windoffshore";
    }
  }

  if (props.source === "timeplot") {
    sharingUrl += "_"
    switch (props.currentFilter) {
      case "inhabitants":
        sharingUrl += "inwoner/";
        break;
      case "surface":
        sharingUrl += "oppervlakte/";
        break;
      case "energy":
      default:
        sharingUrl += "energie/";
    }
  }
  else {  
    sharingUrl += "/"
  }
  
  let size = "20";
  return (
    <div className={classes.root}>
      <div className={classes.shareWith + " darkbluegreen"}>Delen via:</div>
      <div style={{ display: "inline-block", width: "calc(100%-65px)" }}>
        <Grid item className={classes.buttonContainer}>
          <div className={classes.hoverable}>
            <FacebookShareButton
              //quote={sharingTitle}
              url={sharingUrl}
            >
              <FacebookIcon size={size} round={true} />
            </FacebookShareButton>
          </div>
          <div className={classes.hoverable}>
            <TwitterShareButton
              //title={sharingTitle}
              url={sharingUrl}
            >
              <TwitterIcon size={size} round={true} />
            </TwitterShareButton>
          </div>
          <div className={classes.hoverable}>
            <LinkedinShareButton
              //title={sharingTitle}
              url={sharingUrl}
            >
              <LinkedinIcon size={size} round={true} />
            </LinkedinShareButton>
          </div>
        </Grid>
      </div>
    </div>
  );
}
